import { SVGProps } from 'react';

const SvgSecurity = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 18" {...props}>
        <path d="M7 9h5.444c-.412 3.197-2.55 6.051-5.444 6.938V9H1.556V4.567L7 2.147M7 .445 0 3.555v4.667c0 4.317 2.987 8.346 7 9.333 4.013-.987 7-5.016 7-9.333V3.555L7 .445Z" />
    </svg>
);
export default SvgSecurity;
